// extracted by mini-css-extract-plugin
module.exports = {"detailsItem":"styles_detailsItem__cmBGd","linkTitle":"styles_linkTitle__bV5cF","link":"styles_link___v8CK"};